import Backbone from "backbone";
import inject from "scripts/ioc/inject";
import AnthologyCollectionPageNavView from "scripts/views/anthologyCollectionPageNavView";
import BaseMediaDetailsPageView from "scripts/views/baseMediaDetailsPageView";

import templateAnthologyCollectionPage from "templates/anthologyCollectionPage.hbs";

const chan = Backbone.Radio.channel;

class AnthologyCollectionPageView extends BaseMediaDetailsPageView {
  constructor(
    options,
    breadcrumbService = inject("breadcrumbService"),
    connectionService = inject("connectionService"),
    securityService = inject("securityService"),
  ) {
    super(options, breadcrumbService, connectionService, securityService);

    this.model.on(
      "change:presentationType",
      this.onPresentationTypeChangeSaveUserPreference,
      this,
    );

    chan("controllerView").reply(
      "anthologyCollectionPageView",
      this.replyPageView,
      this,
    );
  }

  get template() {
    return templateAnthologyCollectionPage;
  }

  render() {
    super.render();

    this.renderCurationButton();
    this.renderPageHeaderDescriptionContainer();
  }

  createNavView() {
    return new AnthologyCollectionPageNavView({
      model: this.model,
      anthologyCollectionModel: this.mediaModel,
    });
  }

  getBreadcrumbText() {
    return this.mediaModel.get("name");
  }

  getDocumentTitle() {
    return `${this.mediaModel.get("name")}`;
  }
}

export default AnthologyCollectionPageView;
